import React from 'react'
import { ExclamationCircleOutlined} from "@ant-design/icons";
import { Modal } from 'antd';
import map from "lodash/map";

const HeadersMissingModal = ({missingHeadersModal, setMissingHeadersModal, missingHeaders}) => {
  return (
       <Modal
                open={missingHeadersModal}
                title={
                    <span style={{ display: "flex", alignItems: "center", color: "#cf1322" }}>
                        <ExclamationCircleOutlined style={{ marginRight: 8 }} />
                        Missing Required rows
                    </span>
                }
                onCancel={() => setMissingHeadersModal(false)}
                centered
            >
                <p className="mb-4">
                    The uploaded Excel file is missing the following required rows.
                    Please upload a correct Excel file or download the sample excel file:
                </p>

                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {map(missingHeaders, (h) => (
                        <div
                            key={h}
                            style={{
                                background: "#fff7f6",
                                padding: "10px 12px",
                                borderRadius: 6,
                                borderLeft: "4px solid #ff4d4f",
                                fontWeight: 500,
                                color: "#cf1322",
                            }}
                        >
                            {h}
                        </div>
                    ))}
                </div>
            </Modal>
  )
}

export default HeadersMissingModal